import { memo, Fragment, useCallback, FC } from 'react'
import { Flex, Tag, TagLabel, TagCloseButton } from '@chakra-ui/react'

type Props = {
  tags: string[]
  size?: string
  removeTag: (tag: string) => void
  updateTag: (tag: string) => void
  validate?: (value: string) => boolean
}

const TagsList: FC<Props> = ({ tags, size, updateTag, removeTag, validate }) => {
  const isValidValue = useCallback((value: string) => {
    return validate ? validate(value) : true
  }, [])

  const isNotRestricted = useCallback((value: string) => {
    if (value.includes('api:')) return false
    if (value.includes('dw:')) return false
    return true
  }, [])

  const onUpdateTag = useCallback((tag: string) => {
    updateTag(tag)
    removeTag(tag)
  }, [])

  return (
    <Fragment>
      {tags.length > 0 && (
        <Flex gap={2} flexWrap="wrap">
          {tags.map((tag) => {
            return (
              <Tag cursor="pointer" color="light" bg={isValidValue(tag) ? 'success' : 'danger'} key={tag} size={size}>
                <TagLabel py={1} onClick={() => onUpdateTag(tag)}>
                  {tag}
                </TagLabel>

                {isNotRestricted(tag) && <TagCloseButton onClick={() => removeTag(tag)} />}
              </Tag>
            )
          })}
        </Flex>
      )}
    </Fragment>
  )
}

export default memo(TagsList)
